import { createSlice } from '@reduxjs/toolkit';

const ServiceTypeReducer = createSlice({
    name:'service_type',
    initialState:{
        value:'none'
    },
    reducers:{
        ServiceSelector:{
            reducer:(state, action) => (state = action.payload),
            prepare: (value) => ({ payload: value }),
        }
    }
})

export const {ServiceSelector} = ServiceTypeReducer.actions;
export default ServiceTypeReducer.reducer
